import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueHtml2Canvas from "vue-html2canvas";
import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);
Vue.use(VueHtml2Canvas);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  data() {
    return {
      mobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      loader: false,
      alertDialog: false,
      alertMessage: "Hello",
    };
  },
  methods: {
    alert(msg) {
      const vm = this;
      console.log(msg);
      vm.alertDialog = true;
      vm.alertMessage = msg;
    },
  },
  render: (h) => h(App),
}).$mount("#app");
